import { siteUrl } from '../site/metadata';
import { buildEnglishIqResultPath } from './build-english-iq-result-path';

export function buildEnglishIqResultWebUrl(shareId: string, locale?: string): string {
  return `${siteUrl}${buildEnglishIqResultPath(shareId, locale)}`;
}
